var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSq1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sq1 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M250.096 279.719L292.691 450.002H207.491L250.096 279.719Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M279.823 250.008L449.989 207.482V292.524L279.823 250.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M250.096 220.298L207.541 50.222H292.637L250.096 220.298Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M220.368 250.008L49.989 292.579V207.429L220.368 250.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M272.13 227.762L319.764 50.001H449.989V180.151V180.565L272.13 228.208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M227.836 227.996L49.989 180.362V50.222H180.183H180.621L228.283 227.996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M272.13 272.246L319.764 450.002H449.989V319.88V319.437L272.13 271.813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M227.836 272.029L49.989 319.662V449.784H180.183H180.621L228.283 272.029"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSq1);
export default __webpack_public_path__ + "static/media/sq1.aac95ed85135e64792dfc370f4a153cc.svg";
export { ForwardRef as ReactComponent };